import { Infobox } from "../../components/Infobox";

export enum ToastAction {
  ADD_TOAST = 'ADD_TOAST',
  REMOVE_TOAST = 'REMOVE_TOAST'
}

export const addToast = (data: Infobox) => ({
  type: ToastAction.ADD_TOAST,
  data
})

export const removeToast = (index: number) => ({
  type: ToastAction.REMOVE_TOAST,
  data: index
})
